import { useEffect }                                           from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom'; // Import useLocation
import AboutUs                                                 from './modules/AboutUs/AboutUs';
import AddProperty                                             from './modules/addProperty/AddProperty';
import AllHome                                                 from './modules/AllHome/AllHome';
import RecentViewed                                            from './modules/allRecentViewed/RecentViewed';
import AllSavedProperties                                      from './modules/allSavedProperties/allSavedProperties';
import Login                                                   from './modules/authentication/login/login';
import ContactUs                                               from './modules/contactUs/contactUs';
import Conversation                                            from './modules/conversation/conversation';
import Details                                                 from './modules/details/details';
import HomeTour                                                from './modules/homeTour/HomeTour';
import LandingPage                                             from './modules/landingPage/landingPage';
import MyProperties                                            from './modules/myProperties/myProperties';
import RequestHomeTour                                         from './modules/requestHomeTour/requestHomeTour';
import SearchScreen                                            from './modules/Search/Search';
import { getMyInfoApi }                                        from './modules/settings/myProfile/apis/apis';
import Settings                                                from './modules/settings/settings';
import Footer                                                  from './reuseableComponents/Footer/Footer';
import Navbar                                                  from './reuseableComponents/Navbar/Navbar';

function AppContent() {
  const location = useLocation();

  const authPages = ['/login', '/signup', '/resetPassword', "/verify-otp", "/newPassword"];

  const getMyInfoFunc = async () => {
    try {
      let result = await getMyInfoApi();

      if (result?.data?.success) {
        localStorage.setItem("userId", result?.data?.data?.id)
        localStorage.setItem("loginUserData", JSON.stringify(result?.data?.data))
      }
      else {
        localStorage.setItem("userLogin", false)
      }
    }
    catch (err) {
      localStorage.setItem("userLogin", false)
    }
  };

  useEffect(() => {
    getMyInfoFunc()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const storedUserId = localStorage.getItem("userId");

    const handleStorageChange = (event) => {
      if (event.key === "userId") {
        const newUserId = event.newValue;

        if (newUserId !== storedUserId) {
          alert("You have been logged out because another user logged in.");
          localStorage.clear();
          window.location.reload();
        }
      }
    };

    window.addEventListener("storage", handleStorageChange);
    return () => {
      window.removeEventListener("storage", handleStorageChange);
    };
  }, []);

  return (
    <>
      { !authPages.includes(location.pathname) && <Navbar/> }
      <Routes>
        <Route exact path="/" element={ <LandingPage/> }/>
        <Route exact path="/login" element={ <Login/> }/>
        <Route exact path="/signup" element={ <Login/> }/>
        <Route exact path="/resetPassword" element={ <Login/> }/>
        <Route exact path="/newPassword" element={ <Login/> }/>
        <Route exact path="/verify-otp" element={ <Login/> }/>
        <Route exact path="/details/:id" element={ <Details/> }/>
        <Route exact path="/settings" element={ <Settings/> }/>
        <Route exact path="/contactUs" element={ <ContactUs/> }/>
        <Route exact path="/savedProperties" element={ <AllSavedProperties/> }/>
        <Route exact path="/myProperties" element={ <MyProperties/> }/>
        <Route exact path="/allHomes" element={ <AllHome/> }/>
        <Route exact path="/requestHomeTour/:id" element={ <RequestHomeTour/> }/>
        <Route exact path="/searchProperty" element={ <SearchScreen/> }/>
        <Route exact path="/conversation" element={ <Conversation/> }/>
        <Route exact path="/aboutUs" element={ <AboutUs/> }/>
        <Route exact path="/addProperty" element={ <AddProperty/> }/>
        <Route exact path="/updateProperty/:id" element={ <AddProperty/> }/>
        <Route exact path="/homeTourRequest" element={ <HomeTour/> }/>
        <Route exact path="/recentViews" element={ <RecentViewed/> }/>
      </Routes>

      { !authPages.includes(location.pathname)  && <Footer/> }
    </>
  );
}

function App() {
  return (
    <Router>
      <AppContent/>
    </Router>
  );
}

export default App;
